module.exports = __webpack_public_path__ + "static/media/step3.d83c104f.svg";